import { render, staticRenderFns } from "./uploadPaper.vue?vue&type=template&id=95d1a648&scoped=true"
import script from "./uploadPaper.vue?vue&type=script&lang=js"
export * from "./uploadPaper.vue?vue&type=script&lang=js"
import style0 from "./uploadPaper.vue?vue&type=style&index=0&id=95d1a648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d1a648",
  null
  
)

export default component.exports